import MPagination from './MPagination.vue';

MPagination.install = (app) => {
  app.component('MPagination', MPagination);
};

export { MPagination };
